var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"console-window"},on:{"scroll":_vm.saveScroll}},_vm._l((_vm.$store.state.ws.console),function(value){return _c('div',{domProps:{"innerHTML":_vm._s(value)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }